import React, {useEffect, useState} from 'react';
import PuffLoader from 'react-spinners/PuffLoader';
import Logo from '../assets/Logo';
import EmptyStar from '../assets/images/emptyStar';
import FilledStar from '../assets/images/filledStar';
import Arrow from '../assets/images/arrow';

let tracked = false;

function Landing() {
    const [path, setPath] = useState<string[]>([]);
    const [exercise, setExercise] = useState<any>({});
    const [equipment, setEquipment] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [exercises, setExercises] = useState([]);
    const [impactString, setImpactString] = useState('Impact of exercise');
    const [deepLinkWeb, setDeepLinkWeb] = useState('');
    const [deepLinkApp, setDeepLinkApp] = useState('');

    const isChromeAndroid = (): boolean => {
        const ua = navigator.userAgent.toLowerCase();
        return (
            /android/.test(ua) &&
            /chrome/.test(ua) &&
            !/samsungbrowser/.test(ua)
        );
    };

    const isIOSSafari = (): boolean => {
        const ua = navigator.userAgent;
        return (
            /iPad|iPhone|iPod/.test(ua) &&
            /Safari/.test(ua) &&
            !/CriOS/.test(ua) &&
            !/FxiOS/.test(ua)
        );
    };

    useEffect(() => {
        const pathParts = window.location.pathname.split('/').filter(Boolean); // e.g. ["exercise", "123"]
        setPath(pathParts);

        if (pathParts[0] === 'exercise' && pathParts[1]) {
            setLoading(true);
            if (tracked === false) {
                tracked = true;
                trackOpen(pathParts[1], 'exercise');
            }

            getExercise(pathParts[1]);
        }

        if (pathParts[0] === 'equipment' && pathParts[1]) {
            setLoading(true);
            if (tracked === false) {
                tracked = true;
                trackOpen(pathParts[1], 'equipment');
            }
            getEquipment(pathParts[1]);
        }

        setDeepLinkWeb(`https://kompan.fitness/${pathParts.join('/')}`);
        setDeepLinkApp(`kompanmobile://${pathParts.join('/')}`);
    }, []);

    const trackOpen = async (id: string, type: string) => {
        const url = `https://api.kompan.fitness/track/view`;
        const platform = /iPad|iPhone|iPod/.test(navigator.userAgent)
            ? 'ios'
            : /android/i.test(navigator.userAgent)
            ? 'android'
            : 'other';

        try {
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    entityType: type,
                    entityId: Number(id),
                    platform: platform,
                    source: 'qr_code',
                }),
            });
        } catch (err) {
            console.error('Error tracking:', err);
        }
    };

    const getEquipment = async (id: string) => {
        const url = `https://api.kompan.fitness/equipment/${id}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            });
            if (response.status === 200) {
                const value = await response.json();

                setEquipment(value);
                await getExercises(id);
            }
        } catch (err) {
            console.error('Error fetching exercise:', err);
        }
    };

    const getExercises = async (id: string) => {
        const url = `https://api.kompan.fitness/exercises`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            });
            if (response.status === 200) {
                const value = await response.json();

                const filteredExercises = value.filter(
                    (exercise: any) => exercise.equipmentId == id
                );

                setExercises(filteredExercises);
                setLoading(false);
            }
        } catch (err) {
            console.error('Error fetching exercise:', err);
        }
    };

    const getExercise = async (id: string) => {
        const url = `https://api.kompan.fitness/exercises/${id}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            });
            if (response.status === 200) {
                const value = await response.json();
                setExercise(value);
                await getTranslationString();
            }
        } catch (err) {
            console.error('Error fetching exercise:', err);
        }
    };

    const getTranslationString = async () => {
        const url = `https://api.kompan.fitness/terms/flat`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
            });
            if (response.status === 200) {
                const value = await response.json();
                const impactObj = value.find(
                    (item: any) => item.key === 'impact'
                );
                if (impactObj) {
                    setImpactString(impactObj.value);
                }
            }
        } catch (err) {
            console.error('Error fetching translations:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flex: 1,
                flexDirection: 'column',
            }}
        >
            <div style={{marginTop: 16, marginBottom: 24}}>
                <Logo />
            </div>

            {loading ? (
                <div
                    style={{
                        marginTop: 40,
                        display: 'flex',
                        justifyContent: 'center',
                        paddingBottom: 32,
                    }}
                >
                    <PuffLoader
                        color={'#FF9800'}
                        loading={loading}
                        size={84}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            ) : (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        flexDirection: 'column',
                        paddingBottom: 32,
                        width: '100%',
                    }}
                >
                    {path[0] === 'exercise' && exercise.title && (
                        <>
                            <div
                                style={{
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                }}
                            >
                                <video
                                    width="100%"
                                    height="100%"
                                    style={{
                                        borderRadius: 4,
                                        overflow: 'hidden',
                                    }}
                                    src={exercise.videoUrl}
                                    playsInline
                                    loop
                                    autoPlay
                                    muted
                                />
                            </div>

                            <p style={title}>{exercise.title}</p>
                            <p style={description}>{exercise.description}</p>
                            <p style={musclesInUse}>{impactString}</p>
                            <img
                                style={{height: 200}}
                                src={exercise.muscleManUrl}
                            />
                        </>
                    )}

                    {path[0] === 'equipment' && equipment.title && (
                        <>
                            <img
                                style={{height: 140}}
                                src={equipment.thumbnailUrl}
                            />

                            <p style={title}>{equipment.title}</p>

                            <div className="exercisesContainer">
                                {exercises.map(
                                    (exercise: any, index: number) => (
                                        <a
                                            style={{textDecoration: 'none'}}
                                            href={`https://kompan.fitness/exercise/${exercise.id}`}
                                        >
                                            <div style={exerciseRow}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            width: 60,
                                                            height: 60,
                                                            marginRight: 12,
                                                            objectFit:
                                                                'contain',
                                                        }}
                                                        src={
                                                            exercise.thumbnailUrl
                                                        }
                                                    />

                                                    <div>
                                                        <p style={subtitle}>
                                                            {exercise.title}
                                                        </p>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                            }}
                                                        >
                                                            <div>
                                                                {exercise.difficulty >
                                                                0 ? (
                                                                    <FilledStar />
                                                                ) : (
                                                                    <EmptyStar />
                                                                )}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    marginLeft: 2,
                                                                    marginRight: 2,
                                                                }}
                                                            >
                                                                {exercise.difficulty >
                                                                1 ? (
                                                                    <FilledStar />
                                                                ) : (
                                                                    <EmptyStar />
                                                                )}
                                                            </div>
                                                            <div>
                                                                {exercise.difficulty >
                                                                2 ? (
                                                                    <FilledStar />
                                                                ) : (
                                                                    <EmptyStar />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <Arrow />
                                            </div>

                                            {index !== exercises.length - 1 && (
                                                <div
                                                    style={{
                                                        marginLeft: 88,
                                                        height: 1,
                                                        backgroundColor:
                                                            '#E0E0E0',
                                                    }}
                                                />
                                            )}
                                        </a>
                                    )
                                )}
                            </div>
                        </>
                    )}

                    {/* Always show open/download buttons */}
                    {(isChromeAndroid() && (
                        <a
                            href={deepLinkWeb}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={buttonStyle}
                        >
                            Open in App
                        </a>
                    )) ||
                        (isIOSSafari() && (
                            <a
                                href={deepLinkApp}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={buttonStyle}
                            >
                                Open in App
                            </a>
                        ))}

                    {/* Store button */}
                    {(/iPad|iPhone|iPod/.test(navigator.userAgent) && (
                        <a
                            href="https://apps.apple.com/app/kompan-outdoor-fitness/id1493500028"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{...buttonStyle, marginTop: 8}}
                        >
                            Download on App Store
                        </a>
                    )) ||
                        (/android/i.test(navigator.userAgent) && (
                            <a
                                href="https://play.google.com/store/apps/details?id=com.kompan.kompan"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{...buttonStyle, marginTop: 8}}
                            >
                                Download on Google Play
                            </a>
                        ))}
                </div>
            )}
        </div>
    );
}

const buttonStyle: React.CSSProperties = {
    marginTop: 32,
    fontSize: 16,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 12,
    paddingBottom: 12,
    fontWeight: 500,
    borderRadius: 8,
    background: '#FF9800',
    color: '#ffffff',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    fontFamily: 'Figtree-Medium, Arial',
};

const title: React.CSSProperties = {
    marginTop: 20,
    textAlign: 'center',
    fontSize: 24,
    fontFamily: 'Figtree-Bold, Arial',
};

const description: React.CSSProperties = {
    marginTop: 8,
    fontSize: 17,
    textAlign: 'center',
    fontFamily: 'Figtree-Medium, Arial',
};

const exerciseRow: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    paddingLeft: 16,
    paddingRight: 16,
    height: 88,
};

const musclesInUse: React.CSSProperties = {
    marginTop: 24,
    marginBottom: 8,
    fontSize: 20,
    fontFamily: 'Figtree-Bold, Arial',
};

const subtitle: React.CSSProperties = {
    fontSize: 17,
    fontFamily: 'Figtree-Bold, Arial',
    marginBottom: 2,
    color: '#000000',
};

export default Landing;
